<template>
    <div id="page">
    <div id="outer">
      <div id="title-div">
        <div id="allSpan-div">
          <div id="span-div1">
            <span id="title-span">往年征集</span>
          </div>
        </div>

        <div id="select-banner" style="width:85%;margin-right: 50px;">
          <el-form
            :model="form"
            inline
            style="display: flex; align-items: center">
            <el-form-item label="院校名称" style="display: flex;">
                  <el-input placeholder="院校名称" style="width: 120px;" v-model="form.collegeName" @keyup.enter.native="form.page=1,Collectionplan_index()" clearable=""></el-input>
                </el-form-item>
                <el-form-item label="专业名称" style="display: flex;">
                  <el-input placeholder="专业名称" style="width: 120px;" v-model="form.specialty_title" @keyup.enter.native="form.page=1,Collectionplan_index()" clearable=""></el-input>
                </el-form-item>
                <el-form-item label="所属省份" style="display: flex;">
                  <el-select v-model="form.province" placeholder="全部" clearable @change="form.page=1,Collectionplan_index()" size="small"  style="width:120px;">
                    <el-option v-for="item in cityData" :key="item.title" :label="item.title" :value="item.title">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="批次" style="display: flex;">
                  <el-select @change="form.page=1,Collectionplan_index()" v-model="form.batch" placeholder="全部" size="small"  style="width:150px;">
                    <el-option v-for="item in batch_arr" :key="item" :label="item" :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="组别" style="display: flex;">
                  <el-select @change="form.page=1,Collectionplan_index()" v-model="form.group_d" placeholder="全部" size="small"  style="width:150px;">
                    <el-option v-for="item in group_arr" :key="item" :label="item" :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="年份" style="display: flex;">
                  <el-select @change="form.page=1,Collectionplan_index()" v-model="form.year" placeholder="请选择" size="small"  style="width:100px;">
                    <el-option v-for="item in yearArr" :key="item" :label="item" :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
            <el-form-item style="display: flex">
              <el-button type="success" size="small" @click="form.page=1,Collectionplan_index()">
                查询
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>



      <div style="width:92%;height: 100%;overflow-y: auto;margin: 0 auto;">
        <el-table :data="list" border style="width: 100%" :header-cell-style="{background:'#f5f5f5'}"
          v-loading="loading">
          <el-table-column prop="collegeName" label="学校名称" align="center">
          </el-table-column>
          <el-table-column prop="specialty_title" label="专业名称" align="center">
          </el-table-column>
          <el-table-column prop="one_zhengji" label="一次征集" align="center">
          </el-table-column>
          <el-table-column prop="two_zhengji" label="二次征集" align="center">
          </el-table-column>
        </el-table>
      </div>

      <!-- <div style="width: 100%;margin-top: 20px;display: flex;align-items: center;justify-content: center;padding-bottom: 30px;">
          <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="form.page"
                :page-sizes="[20,100,200]"
                :page-size="form.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
        </div> -->


      </div>
      </div>
</template>
<script>
import cityJson from "@/utils/city.json"
import { Collectionplan_index,selectYear,groupFind,batchGetgroup } from "@/api/gw/zonghe.js"
export default{
  data(){
    return{
      cityData:cityJson,
      list:[],
				form:{
					page:1,
					limit:2000,
					collegeName:"",
					specialty_title:"",
					group_d:"",//组别
					year:"",//年份
					batch:"",//批次
          province:""//选择省份
				},
        loading:false,
        yearArr:[],
        total:20,
        batch_arr:[],
        group_arr:[],
        cityArr:[],
    }
  },
   watch:{
     ["form.batch"](e){
       if(e){
         console.log("批次改变",e);
         this.group_arr = [];
         this.form.group_d = ""
         this.batchGetgroup(e);
       }
     },
   },
  mounted(){
    this.groupFind();
    this.Collectionplan_index();
    // this.selectYear();
  },
  methods:{
    Collectionplan_index(){
      this.loading = true
      const examTypeRaw = localStorage.getItem('selectedExamType');
      const examType = ['1','2','3'].includes(String(examTypeRaw)) ? String(examTypeRaw) : '1';
      let form = { ...this.form, examType };
      Collectionplan_index(form).then(res=>{
        console.log("往年征集",res.data);
        this.total = res.data.total
        this.list = res.data.data
        this.yearArr = [res.data.current_year,res.data.qunian_year,res.data.qian_year]
        if(!this.form.year){
          this.form.year = res.data.current_year
        }
      }).finally(()=>{
        this.loading = false
      })
    },
    groupFind(){
      const examTypeRaw = localStorage.getItem('selectedExamType');
      const examType = ['1','2','3'].includes(String(examTypeRaw)) ? String(examTypeRaw) : '1';
      groupFind({ examType }).then(res=>{
        this.batch_arr = res.data.batch_arr
        // this.group_arr = res.data.group_d_arr
      })
    },
    batchGetgroup(e){
      const examTypeRaw = localStorage.getItem('selectedExamType');
      const examType = ['1','2','3'].includes(String(examTypeRaw)) ? String(examTypeRaw) : '1';
      batchGetgroup({ batch:e, examType }).then(res=>{
        this.group_arr = res.data
      })
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.form.limit = val;
      this.Collectionplan_index();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.form.page = val;
      this.Collectionplan_index();
    },
    selectYear(){
      selectYear({}).then(res=>{
        if(res.data){
						res.data.unshift(Number(res.data[0]) + 1)
						this.form.year = res.data[1]
            this.Collectionplan_index();
					}
					this.yearArr = res.data
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../scss/index.scss';

::v-deep .el-table {
  overflow: visible !important;
}

::v-deep .el-table__header-wrapper {
  position: sticky !important;
  top: 0 !important; //这个值根据实际情况而定
  z-index: 10 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/comprehensive/components/zhengji.vue